// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"0c41fa81","513":"3165b2f2","863":"44b52e6c","970":"ce1e87e6"}[chunkId] + ".chunk.js";
};